"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EtlManualTriggerResourceLog", {
    enumerable: true,
    get: function() {
        return EtlManualTriggerResourceLog;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _baseresourcelog = require("../base-resource-log");
const EtlManualTriggerDomainModel = _zod.z.enum([
    "all",
    "employee",
    "review"
]);
const EtlManualTriggerStatusModel = _zod.z.enum([
    "started",
    "queued",
    "processing",
    "completed"
]);
const EtlManualTriggerResourceLog = _baseresourcelog.BaseResourceLog.extend({
    resource_type: _zod.z.literal("etl"),
    change_type: _zod.z.literal("manual-trigger"),
    data: _zod.z.object({
        domain: EtlManualTriggerDomainModel,
        status: EtlManualTriggerStatusModel,
        started_at: _zod.z.date(),
        completed_at: _zod.z.date().nullish(),
        /** Objects that have not yet gone throw the ETL process, but are queued up. */ objects_to_process: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
        /** Objects that have been successfully processed. */ success_processed_objects: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).nullish(),
        /** Objects that have failed to process. */ fail_processed_objects: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).nullish()
    })
});
